(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('sodLinkUrl', sodLinkUrl);

    function sodLinkUrl(lodash) {
        return function(value, override) {
            const hostname = window.location.hostname;

            if (override) {
                return 'http://' + override + value;
            } else {
                return 'http://' + hostname + value;
            }
        }
    }
})();